import PropTypes from 'prop-types';
import React from 'react';
import {Modal} from 'react-bootstrap';
import styled from 'styled-components';
import '../assets/css/style.css';
import {COLORS} from '../constants';

const StyledHeader =  styled(({headerColor, ...restProps}) => <Modal.Header {...restProps}/>)`
  background-color: ${({headerColor}) => headerColor};
  color: white;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
`;

const StyledTitle = styled(({titleColor, ...restProps}) => <Modal.Title {...restProps}/>)`
  font-size: 20px;
  color: ${({titleColor}) => titleColor};
`;

const PopIn = props => {
  const {children, title, visible, setModalVisible, size, headerColor, titleColor} = props;
  return (
    <Modal
      show={visible}
      onHide={() => setModalVisible(false)}
      size={size}
      dialogClassName={size === 'xl' ? 'modal-90w' : ''}
    >
      <StyledHeader headerColor={headerColor} closeButton>
        <StyledTitle titleColor={titleColor}>{title}</StyledTitle>
      </StyledHeader>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

PopIn.defaultProps = {
  size: 'lg',
  headerColor: COLORS.MAIN_PINK,
  titleColor: COLORS.WHITE,
};

PopIn.propTypes = {
  children: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  setModalVisible: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
  headerColor: PropTypes.string,
  titleColor: PropTypes.string,
};

export default PopIn;
